// @flow

import React from 'react'

type Props = {
  numOfCols: number,
  text: string,
}

const RawNoAvailableTableData = (props: Props) =>
  <tr>
    <td colSpan={props.numOfCols}>
      <div className="text-center">
        {props.text}
      </div>
    </td>
  </tr>

export default RawNoAvailableTableData



// WEBPACK FOOTER //
// ./src/elements/no-available-table-data.js